import React, {useState} from 'react';
import {Link, useNavigate} from "react-router-dom";
import {useForm} from 'react-hook-form';
import clinicService from '../../../services/clinic.service';
import {toast} from 'react-toastify'

const ClinicAdd = () => {
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const {register, handleSubmit, formState: {errors}} = useForm();
    const navigate = useNavigate();
    const onSubmit = (data) => {
        setLoading(true);
        setError(false);
        setSuccess(false);
        setMessage('');

        clinicService.addClinic(data)
            .then(res => {
                setLoading(false);
                setSuccess(true);
                setMessage(res.data.message);
                toast.success("Clinic Created", {position: toast.POSITION.BOTTOM_RIGHT});
                setTimeout(() => navigate('/clinics'), 2000);
            })
            .catch(err => {
                setLoading(false);
                setError(true);
                setMessage(err.response.data.message);
                toast.error("Error while creating clinic", {position: toast.POSITION.BOTTOM_RIGHT});
            });
    };

    return (
        <div className="container-fluid">
            <div className="pagetitle d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div>
                    <h1 className="mb-0">
                        <i className="bi bi-hospital"></i> Add New Clinic
                    </h1>
                    <p className="text-muted">Register a new medical facility</p>
                </div>
                <Link to="/clinics" className="btn btn-sm btn-outline-secondary">
                    <i className="bi bi-chevron-left me-1"></i> Back
                </Link>
            </div>

            <div className="card border-0 shadow-sm rounded-lg overflow-hidden">
                <div className="card-body p-3">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row g-3">
                            {/* Clinic Name */}
                            <div className="col-md-6 p-2">
                                <label className="form-label fw-semibold text-uppercase mb-1">
                                    <i className="bi bi-building me-1"></i> Clinic Name
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <i className="bi bi-hospital text-muted"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className={`form-control border-start-0 ${errors.name ? 'is-invalid' : ''}`}
                                        style={{height: '38px'}}
                                        {...register("name", {required: true})}
                                    />
                                </div>
                                {errors.name &&
                                    <div className="invalid-feedback d-block">Please enter clinic name</div>}
                            </div>

                            {/* Email */}
                            <div className="col-md-6 p-2">
                                <label className="form-label fw-semibold text-uppercase mb-1">
                                    <i className="bi bi-envelope me-1"></i> Email
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <i className="bi bi-at text-muted"></i>
                                    </span>
                                    <input
                                        type="email"
                                        className={`form-control border-start-0 ${errors.email ? 'is-invalid' : ''}`}
                                        style={{height: '38px'}}
                                        {...register("email", {required: true})}
                                    />
                                </div>
                                {errors.email && <div className="invalid-feedback d-block">Valid email required</div>}
                            </div>

                            {/* Phone */}
                            <div className="col-md-6 p-2">
                                <label className="form-label fw-semibold text-uppercase mb-1">
                                    <i className="bi bi-telephone me-1"></i> Phone
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <i className="bi bi-phone text-muted"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className={`form-control border-start-0 ${errors.phone ? 'is-invalid' : ''}`}
                                        style={{height: '38px'}}
                                        {...register("phone", {required: true})}
                                    />
                                </div>
                                {errors.phone && <div className="invalid-feedback d-block">Phone number required</div>}
                            </div>

                            {/* SMS */}
                            <div className="col-md-6 p-2">
                                <label className="form-label fw-semibold text-uppercase mb-1">
                                    <i className="bi bi-chat-left-text me-1"></i> SMS Number
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <i className="bi bi-send text-muted"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className={`form-control border-start-0 ${errors.sms ? 'is-invalid' : ''}`}
                                        style={{height: '38px'}}
                                        {...register("sms", {required: true})}
                                    />
                                </div>
                                {errors.sms && <div className="invalid-feedback d-block">SMS contact required</div>}
                            </div>

                            {/* Logo URL */}
                            <div className="col-md-6 p-2">
                                <label className="form-label fw-semibold text-uppercase mb-1">
                                    <i className="bi bi-image me-1"></i> Logo URL
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <i className="bi bi-link-45deg text-muted"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className={`form-control border-start-0 ${errors.logo ? 'is-invalid' : ''}`}
                                        style={{height: '38px'}}
                                        {...register("logo", {required: true})}
                                    />
                                </div>
                                {errors.logo && <div className="invalid-feedback d-block">Logo URL required</div>}
                            </div>

                            {/* Signature */}
                            <div className="col-md-6 p-2">
                                <label className="form-label fw-semibold text-uppercase mb-1">
                                    <i className="bi bi-pen me-1"></i> Email Signature
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <i className="bi bi-file-earmark-text text-muted"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className={`form-control border-start-0 ${errors.signature ? 'is-invalid' : ''}`}
                                        style={{height: '38px'}}
                                        {...register("signature", {required: true})}
                                    />
                                </div>
                                {errors.signature &&
                                    <div className="invalid-feedback d-block">Email Signature required</div>}
                            </div>

                            {/* Asset Name */}
                            <div className="col-md-6 p-2">
                                <label className="form-label fw-semibold text-uppercase mb-1">
                                    <i className="bi bi-folder me-1"></i> Asset Name
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <i className="bi bi-hdd text-muted"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className={`form-control border-start-0 ${errors.assetName ? 'is-invalid' : ''}`}
                                        style={{height: '38px'}}
                                        {...register("assetName", {required: true})}
                                    />
                                </div>
                                {errors.assetName &&
                                    <div className="invalid-feedback d-block">Asset name required</div>}
                            </div>

                            {/* Website */}
                            <div className="col-md-6 p-2">
                                <label className="form-label fw-semibold text-uppercase mb-1">
                                    <i className="bi bi-globe me-1"></i> Website
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <i className="bi bi-link text-muted"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className={`form-control border-start-0 ${errors.website ? 'is-invalid' : ''}`}
                                        style={{height: '38px'}}
                                        {...register("website", {required: true})}
                                    />
                                </div>
                                {errors.website && <div className="invalid-feedback d-block">Website URL required</div>}
                            </div>

                            {/* Form Actions */}
                            <div className="col-12 mt-4 pt-2 border-top">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        {error && (
                                            <div className="d-flex align-items-center text-danger">
                                                <i className="bi bi-exclamation-circle-fill me-2"></i>
                                                <small>{message}</small>
                                            </div>
                                        )}
                                        {success && (
                                            <div className="d-flex align-items-center text-success">
                                                <i className="bi bi-check-circle-fill me-2"></i>
                                                <small>{message}</small>
                                            </div>
                                        )}
                                    </div>

                                    <div className="d-flex gap-2">
                                        <button
                                            type="reset"
                                            className="btn btn-sm btn-danger px-3"
                                        >
                                            <i className="bi bi-arrow-counterclockwise me-1"></i> Reset
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-sm btn-success px-3"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-1"></span>
                                                    Processing...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bi bi-floppy me-1"></i>
                                                    Save
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ClinicAdd;